import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import HouseKey from '@propertypal/shared/src/resources/images/co-ownership/house-key.jpg';
import Link from 'next/link';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const RED = '#e83a4f';

export const Container = styled.div`
  background-color: ${RED};
  overflow: hidden;
`;

export const Content = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  display: flex;

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const ContentText = styled.div`
  padding: 60px 30px;
  flex: 0 0 50%;
  color: white;

  h2,
  h4,
  p {
    margin: 30px 0;
  }

  h2 {
    font-size: 38px;
  }

  h4 {
    font-size: 24px;
    font-weight: 600;
  }

  p {
    font-size: 20px;
  }

  @media (${mobileXXLargeMax}) {
    padding: 60px 15px;

    img {
      height: 50px;
    }

    h2 {
      font-size: 30px;
    }

    h4 {
      font-size: 20px;
    }
  }
`;

export const ContentImage = styled.div`
  position: relative;
  flex: 1;
`;

export const FadedImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100vw / 2);
  height: 100%;
  background-image: url(${HouseKey.src});
  background-size: cover;
  background-position: center;
  opacity: 0.5;

  @media (${laptopMediumMax}) {
    position: static;
    height: calc(100vw);
    max-height: 750px;
    width: 100%;
  }
`;

export const ButtonLink = styled(Link)`
  display: inline-block;
  background-color: white;
  color: ${RED};
  border-radius: 6px;
  font-weight: bold;
  padding: 12px 25px;
`;
